import { useContext } from "react";
import { SportsCampsContext } from "./context/sportscamps-context";
import { transformDate } from "./data";
import MoreInfo from "./MoreInfoCard/MoreInfo";

const SportsCampsCard = (props) => {
	const { dictionaryWords, setMoreInfoVisible, setSportsCampId } = useContext(SportsCampsContext);

	const handleClick = () => {
		setSportsCampId(props.sportsCamp.activityId);
		setMoreInfoVisible((prevMoreInfoVisible) => !prevMoreInfoVisible);
	};

	return (
		<div className={`c-fiche c-discipline-full ng-scope`} onClick={handleClick} title={props.sportsCamp.activityName}  data-aos="fade-up">
			{
				!props.empty && <div>
				<div className="type">
					<i className="fa fa-fw fa-calendar-alt"></i>
					<span className="ng-binding ng-scope">
						{`${transformDate(
							props.sportsCamp.period.from
						)} - ${transformDate(props.sportsCamp.period.until)}`}
					</span>
				</div>
				<header className="c-fiche__header c-fiche__header-sportscamp">
					<h1 className="title ng-binding" title="">
						{props.sportsCamp.activityName}
					</h1>
				</header>
				<ul className="c-fiche__body">
					<li className="leaf ng-binding">
						<i className="fas fa-fw fa-map-marker-alt"></i>
						{props.sportsCamp.location.locationName}
					</li>
					<li className="leaf ng-binding">
						<i className="fas fa-fw fa-eur"></i>
						{`${props.sportsCamp.price} EUR`}
					</li>
					<li className="leaf ng-binding">
						<i className="fas fa-fw fa-child"></i>
						{props.sportsCamp.ageDescription}
					</li>
				</ul>

				<MoreInfo
					key={props.sportsCamp.key}
					id={props.sportsCamp.key}
					sportsCamp={props.sportsCamp}
					cta={props.sportsCamp.activityName}
				/>
			</div>
			}
		</div>
	);
};

export default SportsCampsCard;
